import { MODULES_NAMES } from '../index';
export const { CUSTOM_DOMAINS: MODULE_NAME } = MODULES_NAMES;
